module.exports = __webpack_public_path__ + "static/media/teams-diversity-no-data.3fe371c1.svg";